import { cx } from './ui.js';

/**
 * The Padhai logo: the sunflower badge with "प", the "adhai" wordmark and,
 * on the welcome screen, the line "Smarter schools. Brighter students."
 *
 * The artwork is the product owner's (`public/brand`), cut from one image with
 * the white taken out. The green wordmark has a mint twin for the dark theme,
 * since forest green on a near-black surface does not read; the badge is the
 * same in both.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <span className={cx('flex items-center gap-1.5', className)}>
      <img
        src="/brand/padhai-badge.png"
        alt=""
        className="size-8 shrink-0"
        width={32}
        height={32}
      />
      <img
        src="/brand/padhai-word.png"
        alt="Padhai"
        className="only-light h-[1.35rem] w-auto"
        width={86}
        height={27}
      />
      <img
        src="/brand/padhai-word-dark.png"
        alt="Padhai"
        className="only-dark h-[1.35rem] w-auto"
        width={86}
        height={27}
      />
    </span>
  );
}

export function BrandLogo({ className }: { className?: string }) {
  return (
    <span className={cx('block', className)}>
      <img
        src="/brand/padhai-logo.png"
        alt="Padhai — smarter schools, brighter students"
        className="only-light h-auto w-full"
        width={720}
        height={229}
      />
      <img
        src="/brand/padhai-logo-dark.png"
        alt="Padhai — smarter schools, brighter students"
        className="only-dark h-auto w-full"
        width={720}
        height={229}
      />
    </span>
  );
}
